/** @type {import('tailwindcss').Config} */
module.exports = {
  corePlugins: {
    preflight: false,
    container: false,
  },
  important: '.dcw',
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    screens: {
      d: '700px',
    },
    extend: {
      colors: {
        theme: 'var(--theme-color)',
        'gray-0': '#7F7F7F',
        'gray-1': '#AFAFAF',
        'gray-2': '#BDBDBD',
        'gray-3': '#E0E0E0',
        'gray-4': '#F2F2F3',
        'gray-20': '#F5F5F5',

        'dark-blue': '#0063D7',
        'brand-red': '#FF1D25',
        'inactive-gray': '#DDE2E5',
        'french-blue-base': '#06273F',
        'french-blue-020': '#ACB7BF',
        'french-blue-030': '#82939F',
        'french-blue-040': '#596F7F',
        'text-secondary': '#494B54',
        'input-background': '#F6F5F5',
        'input-border': '#F3F3F3',
      },
    },
  },
  plugins: [require('@tailwindcss/container-queries')],
}
